module.exports = __webpack_public_path__ + "img/ppt.22b150d4.png";